import React, { useState, useEffect } from "react";
import { FaSave, FaTimes } from "react-icons/fa";
import {
  getAllArticlesByPage,
  addArticle,
  updateArticle,
  deleteArticle,
} from "./../../../services/articlesPagesServices";
import Button from "./../../../components/Button/Button";
import ButtonEdit from "./../../../components/Button/ButtonEdit";
import ButtonDelete from "./../../../components/Button/ButtonDelete";
import { toast } from "react-toastify";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

// Définir les modules de la toolbar
const modules = {
  toolbar: [
    [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ size: [] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ color: [] }, { background: [] }],
    [{ script: "sub" }, { script: "super" }],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link", "image", "video"],
    ["clean"],
  ],
};

const formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "color",
  "background",
  "script",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "video",
];

const ManageArticlesModal = ({ page, onClose }) => {
  const [articles, setArticles] = useState([]);
  const [titreArticle, setTitreArticle] = useState("");
  const [contenuTexte, setContenuTexte] = useState("");
  const [urlImage, setUrlImage] = useState("");
  const [ordre, setOrdre] = useState(0);
  const [editingArticle, setEditingArticle] = useState(null);

  const loadArticles = async () => {
    const result = await getAllArticlesByPage(page.id);
    setArticles(result);
  };

  useEffect(() => {
    loadArticles();
  }, [page.id]);

  const resetForm = () => {
    setTitreArticle("");
    setContenuTexte("");
    setUrlImage("");
    setOrdre(0);
    setEditingArticle(null);
  };

  const handleSaveArticle = async (e) => {
    e.preventDefault();
    if (editingArticle) {
      const updated = await updateArticle({
        id: editingArticle.id,
        page_id: page.id,
        titre_article: titreArticle,
        contenu_texte: contenuTexte,
        url_image: urlImage,
        ordre,
      });
      if (updated) {
        toast.success("Article mis à jour.");
        loadArticles();
        resetForm();
      } else {
        toast.error("Erreur lors de la mise à jour.");
      }
    } else {
      const newArticle = await addArticle({
        page_id: page.id,
        titre_article: titreArticle,
        contenu_texte: contenuTexte,
        url_image: urlImage,
        ordre,
      });
      if (newArticle) {
        toast.success("Article ajouté.");
        loadArticles();
        resetForm();
      } else {
        toast.error("Erreur lors de l'ajout.");
      }
    }
  };

  const handleEditClick = (article) => {
    setEditingArticle(article);
    setTitreArticle(article.titre_article);
    setContenuTexte(article.contenu_texte);
    setUrlImage(article.url_image);
    setOrdre(article.ordre);
  };

  const handleDeleteArticle = async (id) => {
    if (window.confirm("Supprimer cet article ?")) {
      const res = await deleteArticle(id);
      if (res) {
        toast.success("Article supprimé.");
        await loadArticles(); // On attend bien que ça recharge
      } else {
        toast.error("Erreur lors de la suppression.");
      }
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 overflow-y-auto">
      <div className="modal-box bg-white p-4 rounded-lg shadow-lg dark:bg-gray-400 w-[700px] max-h-[90vh] overflow-y-auto">
        <h3 className="text-xl font-bold uppercase p-3 mb-4 text-center text-white bg-primary rounded-md shadow">
          Articles de la page "{page.titre}"
        </h3>

        <form onSubmit={handleSaveArticle}>
          <input
            type="text"
            placeholder="Titre de l'article"
            value={titreArticle}
            onChange={(e) => setTitreArticle(e.target.value)}
            className="input input-bordered w-full mb-3"
            required
          />

          <ReactQuill
            value={contenuTexte}
            onChange={setContenuTexte}
            modules={modules}
            formats={formats}
            className="mb-3 bg-slate-200 dark:bg-slate-100 dark:text-black"
          />

          <input
            type="text"
            placeholder="URL image"
            value={urlImage}
            onChange={(e) => setUrlImage(e.target.value)}
            className="input input-bordered w-full mb-3"
          />

          <input
            type="number"
            placeholder="Ordre"
            value={ordre}
            onChange={(e) => setOrdre(parseInt(e.target.value))}
            className="input input-bordered w-full mb-3"
          />

          <div className="flex justify-center space-x-2 mt-4">
            <Button
              text={editingArticle ? "Enregistrer modifications" : "Ajouter"}
              icon={FaSave}
              type="submit"
              className="btn-primary gap-2"
            />
            {editingArticle && (
              <Button
                text="Annuler modification"
                icon={FaTimes}
                onClick={resetForm}
                type="button"
                className="btn-ghost gap-2"
              />
            )}
          </div>
        </form>

        <table className="w-full text-sm text-left border border-gray-300 dark:border-gray-600 mt-6">
          <thead className="bg-gray-100 dark:bg-gray-800">
            <tr>
              <th className="p-2">Titre</th>
              <th className="p-2">Ordre</th>
              <th className="p-2">Actions</th>
            </tr>
          </thead>
          <tbody>
            {articles.map((article) => (
              <tr
                key={article.id}
                className="border-t border-gray-300 dark:border-gray-600"
              >
                <td className="p-2">{article.titre_article}</td>
                <td className="p-2">{article.ordre}</td>
                <td className="p-2 flex gap-1">
                  <ButtonEdit onClick={() => handleEditClick(article)} />
                  <ButtonDelete
                    onClick={() => handleDeleteArticle(article.id)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="flex justify-center mt-4">
          <Button text="Fermer" icon={FaTimes} onClick={onClose} />
        </div>
      </div>
    </div>
  );
};

export default ManageArticlesModal;
